import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";
import CenteredHeader from "../../Molecules/CenteredHeader/CenteredHeader";
import Imageholder01 from "../../../assets/img/Imageholder01.jpg";
import FAMILY_DASHBOARD_SECTION_IMAGE from "../../../assets/img/FAMILY_DASHBOARD_SECTION_IMAGE.jpg";
import Imageholder02 from "../../../assets/img/Imageholder02.jpg";
import FormShell from "../../Organisms/FormShell/FormShell";
import DynamicFormik from "../../Organisms/DynamicFormik/DynamicFormik";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import Grupo_1342 from "../../../assets/img/Grupo_1342.png";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryTwoButtonsSection from "../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import content from "./content";
import {useLanguageCtx} from "../../../store/providers/LanguageContext";

const IndustryEquipoPesado = () => {
	const { dropdownHeader } = useScrollCtx();
	const {language} = useLanguageCtx();

	return (
		<>
			<ChangeableHeaderV2
				titleBanner={content[language].titleBanner}
				spanTitleYellow={content[language].spanTitleYellow}
				appearSecondNavbar={dropdownHeader}
			/>
			<div className="mt-40">
				<CenteredHeader
					boldText={content[language].equipo_pesado_bold_title}
					yellowText={content[language].equipo_pesado_red_title}
				/>
			</div>
			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{ img: Imageholder01, alt: "Camión de Carga" }}
					boldText={content[language].equipo_pesado_bold_text}
					paragraphs={[content[language].equipo_pesado_text]}
				/>
			</div>
			<IndustryLightBlueSection
				checkText={content[language].beneficios_list}
				yellowText={content[language].beneficios_red_title}
				boldText={content[language].beneficios_bold_title}
			/>
			<IndustryBannerBgSection route="equipo-pesado">
				<IndustryImageTextSection
					inBanner={true}
					image={{ img: Grupo_1342, alt: "Contrucción" }}
					switchOrder
					yellowText={content[language].caracteristicas_red_title}
					boldText={content[language].caracteristicas_bold_text}
					paragraphs={[content[language].caracteristicas_text]}
					checkText={content[language].caracteristicas_list}
				/>
			</IndustryBannerBgSection>

			<IndustryTwoButtonsSection />

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].dashboard_red_title}
					boldText={content[language].dashboard_bold_title}
				/>
			</div>

			<div className="top-space-section no-top-space-responsive">
				<IndustryImageTextSection
					image={{ img: FAMILY_DASHBOARD_SECTION_IMAGE, alt: "Mapa Satelital" }}
					// imgShadow
					imgRadius
					boldText={content[language].dashboard_bold_text}
					paragraphs={[content[language].dashboard_text]}
					checkText={content[language].dashboard_list}
					responsiveImgPosition="last"
				/>
			</div>
			<div className="top-space-section">
				<IndustryImageTextSection
					image={{ img: Imageholder02, alt: "software" }}
					// imgShadow
					imgRadius
					boldText={content[language].software_bold_text}
					paragraphs={content[language].software_text}
					switchOrder
				/>
			</div>
			<div className="top-space-section">
				<FormShell contact title={content[language].form_title}>
					<DynamicFormik
						buttonContent={content[language].form_button_text}
						field_1={content[language].formik_fields[0]}
						field_2={content[language].formik_fields[1]}
						field_3={content[language].formik_fields[2]}
						field_4={content[language].formik_fields[3]}
						field_5={content[language].formik_fields[4]}
						field_6={content[language].formik_fields[5]}
						field_7={content[language].formik_fields[6]}
					/>
				</FormShell>
			</div>
		</>
	);
};

export default IndustryEquipoPesado;
